const zone = () => `copilot/zone`;

export const zoneEndpoints = { zone };
